import {Link} from 'react-router-dom'
import {KTSVG} from '../../../../_metronic/helpers'

export const Card = ({link, title, value, icon, isLinkAvailable = true, onClick}: any) => (
  <Link
    to={link}
    className={`col-lg-2 col-md-4 col-sm-6 col-xs-12 bg-light-primary px-5 py-5 rounded-2 mx-3 my-5 ${!isLinkAvailable ? 'cursor-pointer pe-none' : ''}`}
    onClick={onClick}
  >
    <KTSVG
      path={icon ? icon : '/media/icons/duotune/general/gen032.svg'}
      className='svg-icon-2x svg-icon-primary d-block my-2'
    />
    <div className='text-primary fw-bold fs-6'>
      <div className='text-capitalize'>{title}</div>
      <div className='text-primary fw-bold fs-6'>{value}</div>
    </div>
  </Link>
)
